import React from 'react';
import TrainingBloc from './TrainingBloc';
import { Button, Icon } from 'semantic-ui-react';
import RestBloc from './RestBloc';
import { TrainingBlocClass, IBloc, IBlocGroup, RestBlocClass } from '../classes';
import '../style/exerciseContainer.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import { useResponsive } from '../../../utils/useResponsive';

interface IExercciseContainerProps extends WithTranslation{
    blocGroupContainer: IBlocGroup[];
    isAdmin:boolean
    hangboard: string;
    intensityType: string;
}

const ExerciseContainerEdit =(props: IExercciseContainerProps) =>{
    const { isMobile, isDesktop } = useResponsive();
    
    const displayBlocGroup = () => {
        return props.blocGroupContainer.map((blocGroup: IBlocGroup, index) =>
            blocGroup.multiplier ?
                <div key={index} className='inner exerciseContainer'>
                    <div className='blocHeader'>
                        {isDesktop && (
                            <Button className='delBlocBtn' onClick={() => blocGroup.deleteSelf(blocGroup.id)}>
                                <Icon name='delete' size='large'></Icon>
                                <p>{props.t('btn.delBloc')}</p>
                            </Button>
                        )}
                        {isMobile && (
                            <Button className='delBlocBtnMobile' onClick={() => blocGroup.deleteSelf(blocGroup.id)}>
                                <Icon name='delete' size='large'></Icon>
                            </Button>
                        )}
                        <h1>{props.t('bloc.set')+' '+ blocGroup.index}</h1>
                        <div className='repSelector'>
                            <Button className='minusButton' onClick={() => blocGroup.setMultiplier('-')}>
                                <Icon name='minus' size='large'></Icon>
                            </Button>
                            <span className='propertyLayout' id="multiplierLayout">
                                <h2>x{blocGroup.multiplier}</h2>
                            </span>

                            <Button className='plusButton' onClick={() => blocGroup.setMultiplier('+')}>
                                <Icon name='plus' size='large'></Icon>
                            </Button>
                        </div>
                        
                        
                    </div>
                    <div className='repsContainer'>
                        {displayBlocs(blocGroup.blocs, blocGroup.deleteBloc, blocGroup.setRestTime, blocGroup.displayRestTime, props.intensityType)}
                    </div>
                    <div className='setFooter'>
                        <Button fluid onClick={() => {
                            blocGroup.addBloc("hang");
                            blocGroup.addBloc("rest");
                        }}> <Icon name='plus' size='large' className='addHangIcon'></Icon> <div className='addHangButtonContent'>{props.t('bloc.addHang').toUpperCase()}</div> </Button>
                    </div>
                    
                </div>
                :
                displayBlocs(blocGroup.blocs, blocGroup.deleteBloc, blocGroup.setRestTime, blocGroup.displayRestTime, props.intensityType)

        );
    }
    
    const displayBlocs=(blocs: [IBloc], deleteBloc, setRestTime, displayRestTime, intensityType)=>{
        return blocs.map((bloc: IBloc, index)=>{
            if (bloc instanceof TrainingBlocClass)
                return (<TrainingBloc key={index} bloc={bloc} hangboard={props.hangboard} handleRestTime={setRestTime} handleDisplayRestTime={displayRestTime} handleDelete={deleteBloc} isAdmin={props.isAdmin} intensityType={props.intensityType} />)
            else if (blocs.length == 1 && bloc instanceof RestBlocClass)
                return (<RestBloc key={index} bloc={bloc} handleDelete={deleteBloc}/>)
            });
    }

    return (
        <div className='exerciseContainer'>
            {displayBlocGroup()}       
        </div>
    )
}

export default withTranslation('exerciseCreator') (ExerciseContainerEdit);